// extracted by mini-css-extract-plugin
module.exports = {"collapse":"style_collapse__q4im9","panel":"style_panel__X2xH3","panelHeader":"style_panelHeader__29b6G","videoIcon":"style_videoIcon__b2dGI","teackIcon":"style_teackIcon__CYLbR"};